import { VisitorLoggedOutSignUpMiniDrawer } from "@faire/deprecated-retailer-visitor-shared/components/App/Batch12SignUpMiniDrawer/VisitorLoggedOutSignUpMiniDrawer";
import { useIsSemDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { SearchOrDiscoverPageBelowFooter } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/BelowFooter";
import { WithSearchPageData } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/DataProvider";
import { WithSearchPageErrorBoundary } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ErrorBoundary";
import { WithFilterRefContext } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/FilterRefContext";
import { FiltersAndResultsSubLayout } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/FiltersAndResultsSubLayout";
import { SearchPageLayout } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/Layout";
import { MaybeSearchPageFilterSideBar } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/MaybeSearchPageFilterSideBar";
import { SearchPageEffects } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageEffects/SearchPageEffects";
import { SearchPageFilterContextProvider } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFilterContextProvider/SearchPageFilterContextProvider";
import { SearchPageFooter } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFooter/SearchPageFooter";
import { SearchPageHeaderAndResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/SearchPageHeaderAndResults";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import React from "react";

export const SearchPage: React.FC = () => {
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const isSEMDiscoverPage = useIsSemDiscoverPage();

  return (
    <WithSearchPageData>
      <SearchPageFilterContextProvider>
        <SearchPageEffects />
        <WithSearchPageErrorBoundary>
          <WithFilterRefContext>
            <SearchPageLayout
              filterAndResults={
                <FiltersAndResultsSubLayout
                  filters={<MaybeSearchPageFilterSideBar />}
                  results={<SearchPageHeaderAndResults />}
                />
              }
              footer={<SearchPageFooter />}
            />
            <SearchOrDiscoverPageBelowFooter />
            {isLoggedOutDiscoverPage && !isSEMDiscoverPage ? (
              <VisitorLoggedOutSignUpMiniDrawer />
            ) : null}
          </WithFilterRefContext>
        </WithSearchPageErrorBoundary>
      </SearchPageFilterContextProvider>
    </WithSearchPageData>
  );
};
